<template>
    <div class="all-page">
        <!-- Header导航栏部分 -->
        <header>
            <ManagementHeaderBar :index="'/aiportalManage'" />
        </header>
        <div class="tab-container">
            <div>
                <!-- <span class="title-text">{{ $t("aiportal") }}</span> -->
                <el-tabs v-model="activeTab" type="card" class="">
                    <el-tab-pane :label="$t('AiPortalSetting.AIPm')" name="portal">
                    </el-tab-pane>
                    <el-tab-pane :label="$t('AiPortalSetting.MIM')" name="other">
                    </el-tab-pane>
                </el-tabs>
            </div>
            <AiPortalTab v-if="activeTab === 'portal'" />
            <AiPortalModel v-if="activeTab === 'other'" />
        </div>
    </div>
</template>

<style scoped>
.all-page {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
}

.header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
}

/* Tab相关样式 */
.tab-container {
    padding: 0 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
    margin-top: 4.5rem;
}

</style>

<script lang="ts">
import { onMounted, inject, ref, computed } from 'vue';
import { AxiosInstance } from "axios";
import ManagementHeaderBar from '@/components/ManagementHeaderBar.vue'
import AiPortalModel from '@/components/AiPortalModel.vue'
import AiPortalTab from '@/components/AiPortalTab.vue'

export default {
    name: 'AiPortalManageView',
    components: {
        ManagementHeaderBar,
        AiPortalTab,
        AiPortalModel
    },
    setup() {
        // Tab切换状态
        const activeTab = ref('portal');

        return {
            activeTab
        };
    }
}
</script>
